/**
 * Constantes para o componente de appointment
 */

// Configurações de calendário
export const CALENDAR_CONFIG = {
  MONTHS_TO_SHOW: 6,
  START_FROM_CURRENT_MONTH: true,
  ENABLE_PAST_DATES: true,
  ENABLE_FUTURE_DATES: false,
} as const;

// Tipos de appointment
export const APPOINTMENT_TYPES = {
  TRAINING: 1,
  PUNCTUALITY: 2,
  ATTENDANCE: 3,
} as const;

// Labels dos tipos de appointment
export const APPOINTMENT_TYPE_LABELS = {
  [APPOINTMENT_TYPES.TRAINING]: 'Treinamento',
  [APPOINTMENT_TYPES.PUNCTUALITY]: 'Pontualidade',
  [APPOINTMENT_TYPES.ATTENDANCE]: 'Assiduidade',
} as const;

// Configurações de tags
export const TAG_CONFIG = {
  COLORS: {
    RED: 'red-background',
    ORANGE: 'orange-background',
    YELLOW: 'yellow-background',
    GREEN: 'green-background',
    BLUE: 'blue-background',
    PURPLE: 'purple-background',
    GRAY: 'gray-background',
    GREEN_LIGHT: 'green-light-background',
  },
  DESCRIPTIONS: {
    RED: 'Falha Grave',
    ORANGE: 'Alerta (Erro cometido as vezes)',
    YELLOW: 'Atenção (Corrigir de forma educativa)',
    GREEN: 'Dever cumprido!',
    BLUE: 'Acima da média',
    PURPLE: 'Ótimo, Parábens, Excelente!',
    GRAY: 'Sem avaliação',
    GREEN_LIGHT: 'Bom desempenho',
  },
} as const;

// Configurações de modal
export const MODAL_CONFIG = {
  SIZES: {
    SM: 'modal-sm',
    MD: 'modal-md',
    LG: 'modal-lg',
    XL: 'modal-xl',
  },
  ANIMATION_DELAY: 100,
} as const;

// Configurações de formulário
export const FORM_CONFIG = {
  VALIDATION: {
    REQUIRED: 'Campo obrigatório',
    MIN_LENGTH: 'Mínimo de caracteres não atingido',
    MAX_LENGTH: 'Máximo de caracteres excedido',
    INVALID_EMAIL: 'Email inválido',
    INVALID_DATE: 'Data inválida',
  },
  DEBOUNCE_TIME: 300,
} as const;

// Configurações de API
export const API_CONFIG = {
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
} as const;

// Configurações de cache
export const CACHE_CONFIG = {
  TTL: 300000, // 5 minutos
  MAX_SIZE: 100,
} as const;

// Configurações de performance
export const PERFORMANCE_CONFIG = {
  VIRTUAL_SCROLL_THRESHOLD: 100,
  DEBOUNCE_TIME: 300,
  THROTTLE_TIME: 100,
} as const;

// Mensagens de erro
export const ERROR_MESSAGES = {
  GENERIC: 'Ocorreu um erro inesperado',
  NETWORK: 'Erro de conexão',
  VALIDATION: 'Dados inválidos',
  PERMISSION: 'Sem permissão para esta ação',
  NOT_FOUND: 'Recurso não encontrado',
} as const;

// Mensagens de sucesso
export const SUCCESS_MESSAGES = {
  CREATED: 'Criado com sucesso',
  UPDATED: 'Atualizado com sucesso',
  DELETED: 'Excluído com sucesso',
  SAVED: 'Salvo com sucesso',
} as const;

// Configurações de data
export const DATE_CONFIG = {
  FORMAT: 'dd/MM/yyyy',
  LOCALE: 'pt-BR',
  TIMEZONE: 'America/Sao_Paulo',
} as const;

// Configurações de layout
export const LAYOUT_CONFIG = {
  BREAKPOINTS: {
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200,
  },
  GRID_COLUMNS: 12,
} as const;
